import { isEqual } from "lodash";
import { useSetRecoilState } from "recoil";

import {
  IStationRouteComputedData,
  stationRouteHasUnsavedStationsChangeAtom,
} from "@ryde/shared";

export const useStationRouteStationsUpdateInfo = () => {
  const setStationRouteUnsavedDistancesChange = useSetRecoilState(
    stationRouteHasUnsavedStationsChangeAtom,
  );

  const setStationRouteHasStationChangeComputed = (
    prevMetadata: IStationRouteComputedData | undefined,
    nextMetadata: IStationRouteComputedData | undefined,
  ): void => {
    const stationsFrom = prevMetadata?.stationInfos?.map(x => x.id);
    const stationsTo = nextMetadata?.stationInfos?.map(x => x.id);

    if (!isEqual(stationsFrom, stationsTo)) {
      setStationRouteUnsavedDistancesChange(true);
    }
  };

  return { setStationRouteHasStationChangeComputed };
};
